import React from 'react'
import classes from './Header.module.css'

const Header = () => {
  return (
    <header>
      <h2 className={classes.title}>Police Crime Report</h2>
    </header>
  )
}
export default Header
